import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-requirements-engineering',
  standalone: true,
  imports: [],
  templateUrl: './requirements-engineering.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './requirements-engineering.component.scss'
})
export class RequirementsEngineeringComponent {

}
